module.exports = __webpack_public_path__ + "img/purchase--icon.245d6b8c.svg";